import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CmsParagraphComponent } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';

@Component({
    selector: 'app-footer-container',
    templateUrl: './footer-container.component.html',
    styleUrl: './footer-container.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FooterContainerComponent {

  public componentData: CmsParagraphComponent;

  constructor(public component: CmsComponentData<CmsParagraphComponent>) { }

  ngOnInit(): void {
    this.component.data$.subscribe((data) => {
      this.componentData = data;
    });
  }
}
